import { createFileRoute } from "@tanstack/react-router";
import { AppAuthorizationPage } from "@/pages/AppAuthorizationPage";
import { ConnectedApplicationsPage } from "@/pages/ConnectedApplicationsPage";

export const Route = createFileRoute("/app-auth")({
  validateSearch: (search: Record<string, unknown>): { requestId: string } => ({
    requestId: typeof search.requestId === "string" ? search.requestId : "",
  }),
  component: AppAuthorizationRoute,
});

function AppAuthorizationRoute(): React.ReactNode {
  const { requestId } = Route.useSearch();
  return requestId === "" ? (
    <ConnectedApplicationsPage />
  ) : (
    <AppAuthorizationPage requestId={requestId} />
  );
}
